import { render, staticRenderFns } from "./AllSearchReportSubmissions.vue?vue&type=template&id=35b58bfe&scoped=true&"
import script from "./AllSearchReportSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllSearchReportSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllSearchReportSubmissions.vue?vue&type=style&index=0&id=35b58bfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b58bfe",
  null
  
)

export default component.exports